<template>
  <div class="ladybugWrapper">
        <img id="ladybug" src="@/assets/images/ladybug.gif" alt="ladybug-animation">
        <svg id="line" width="100%" height="100%" viewBox="0 0 3221 275" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
            <path d="M0,33.192C197.762,3.052 410.389,45.657 588.633,133.846C684.278,181.168 773.788,242.907 880.142,263.547C1130.49,312.133 1294.94,180.933 1513.95,171.219C1661.91,164.656 1803.62,271.958 1974.06,272.975C2362.16,275.292 2715.64,-115.165 3114.7,33.958C3144.75,45.188 3198.2,66.013 3220.79,90.867" style="fill:none;"/>
        </svg>
  </div>
</template>

<script>
import anime from 'animejs';

export default {
    name: 'LadybugAnimation1',
    mounted() {
      const path = anime.path('#line path');
      anime({
        targets: '#ladybug',
        translateX: path('x'),
        translateY: path('y'),
        rotate: path('angle'),
        easing: 'linear',
        duration: 20000,
        loop: true
      });
    },
}
</script>

<style>
.ladybugWrapper {
    position: relative;

}
#ladybug {
    position: absolute;
    width: 60px;
}
</style>